import { setConciergeCategory, setLifestyleCategory } from "./FamilyEngagementPlusService";

export default {
  name: "FamilyEngagementCore",
  props: {
    settings: null,
    arecheckedesdisabled: Boolean,
    facility: null
  },
  created() {
    this.sendDefaultValueForModule();
  },
  computed: {
    isDisableLifestyle(): boolean {
      return !this.facility.featureLifestyle;
    },
    isDisableConcierge(): boolean {
      return !this.facility.featureConcierge;
    },
    familyEngagementPlusBundle: {
      get() {
        return this.conciergeCategory && this.lifestyleCategory;
      }
    },
    conciergeCategory: {
      get() {
        return (
          (this.facility.featureConcierge ?? true) &&
          (this.facility.additionalServicesEnabled ?? true) &&
          (this.facility.additionalServicesBookingsEnabled ?? true)
        );
      }
    },
    lifestyleCategory: {
      get() {
        return (
          (this.facility.featureLifestyle ?? true) &&
          (this.facility.isEnableWeeklyLifestyleEventsReport ?? true) &&
          (this.facility.isStaffHubCalendar ?? true) &&
          (this.facility.lifestyleProgramsTileOnMyHubEnabled) &&
          (this.facility.isEnableResidentEventPictures ?? true) &&
          (this.facility.isCanCreateWings ?? true)
        );
      }
    },
  },
  methods: {
    sendDefaultValueForModule() {
      this.$emit('send-bundle-value', this.familyEngagementPlusBundle)
    },
    familyEngagementPlusBundleUpdate(value) {
      this.conciergeCategoryUpdate(value);
      this.lifestyleCategoryUpdate(value);
    },
    conciergeCategoryUpdate(value) {
      setConciergeCategory(this.facility, value)

      if(value) {
        this.$emit('send-bundle-value', this.familyEngagementPlusBundle)
      }
    },
    lifestyleCategoryUpdate(value) {
      setLifestyleCategory(this.facility, value)

      if(value) {
        this.$emit('send-bundle-value', this.familyEngagementPlusBundle)
      }
    }
  }
}
